import React from 'react';

import { BaseButton, Stack, Typography } from '@lyearn/ui';

import { UploadButtonProps } from './types';

function UploadButton(props: UploadButtonProps) {
  const { placeholder, PlaceholderIcon, supportedMimeTypes, onClick, isDisabled } = props;

  return (
    <BaseButton
      fullWidth
      className="justify-start rounded-8 border border-dashed border-interactive-secondary-hover p-12 xs:flex-row xs:items-center"
      // @ts-ignore
      component="span"
      disabled={isDisabled}
      onClick={onClick}>
      <PlaceholderIcon height={42} width={32} />
      <Stack className="ps-12 xs:justify-center" direction="col">
        <Typography color="text-text-secondary" variant="body-short-02">
          {placeholder}
        </Typography>
        <Typography className="mt-2" color="text-text-placeholder" variant="body-short-03">
          {supportedMimeTypes}
        </Typography>
      </Stack>
    </BaseButton>
  );
}

export default UploadButton;
